<section #fixed_header
         class="app-header {{ main ? 'app-header-main' : 'app-header-fixed'}}">

  <aside class="app-header-gnb-btn-menu">
    <a class="app-header-gnb-btn" (click)="lm.showMenu = true"></a>
  </aside>

  <article *ngIf="main && greeting"
           class="app-header-intro-box"
           (click)="onClickGreeting($event)">
    <div class="app-header-main-txt">
      {{ greeting.title }}
      <img [ngClass]="{'fade-out': !(showHandArrow$ | async)}"
           src="assets/img/img-hand-arrow.gif"
           class="app-header-arrow"
           alt="화살표">
    </div>
    <div class="app-header-sub-txt">{{ greeting.message }}</div>
  </article>

  <article class="app-header-search-box">

    <div class="app-header-search-keyword-box">
      <div class="app-header-search-keyword-wrap {{ cssBear }}">
        <a class="app-header-search-btn"
           (click)="onPushSearchBtn($event, search_box.value)"></a>
        <form [formGroup]="searchForm">
          <input #search_box
                 class="{{ ctlKeyword.value?.length > 0 ? 'with-clear' : '' }}"
                 type="text"
                 formControlName="keyword"
                 [attr.maxlength]="SearchKeywordMaxLength"
                 [placeholder]="GetPlaceholder()"
                 (input)="onInputSearchBox($event)"
                 (paste)="onPasteSearchBox($event, search_box)"
                 (keyup)="onKeyUpSearchBox($event, search_box.value)">
        </form>
        <a class="app-header-clear-btn"
           *ngIf="search_box.value.length > 0"
           (click)="onPushClearBtn($event, search_box)"></a>
      </div>
    </div>

    <div class="app-header-tag-keyword-box">

      <div class="app-header-tag-keyword-wrap">

        <div class="app-header-tag-list">

          <!-- div class="tag-btn-box"
               *ngIf="canGoHistory && history?.list?.length > 0"
               (click)="onClickGoHistory()" -->
          <div class="app-header-tag-btn-box"
               (click)="onClickGoHistory()">
            <div class="app-header-tag-btn">검색 이력</div>
            <div class="app-header-tag-arrow-btn"></div>
          </div>

          <div class="app-header-tag-btn-box"
               *ngFor="let item of history.list; let idx = index">
            <a class="app-header-tag-btn"
               (click)="onHistoryClick(item)">{{ item }}</a>
            <a class="app-header-tag-remove-btn"
               (click)="onHistoryDel(idx)"></a>
          </div>

        </div>

      </div>


    </div>

  </article>

  <section class="app-header-keyword-option-list {{ selectedRegion2 !== null ? 'app-header-type-with-btn' : '' }} {{ mainJaso ? 'app-header-type-with-return' : '' }}"
           *ngIf="showJasoIdx">

    <a class="app-header-map-box {{ showRegionSelect ? 'app-header-type-select' : '' }}"
       *ngIf="GetSelectRegionTxt()" (click)="onMapBtn()">
      <div class="app-header-map-wrap">
        <i class="app-header-ic app-header-ic-map"></i>
        <div class="app-header-map-txt">{{ GetSelectRegionTxt() }}</div>
      </div>
    </a>

    <div class="app-header-list-wrap">
      <div #jasoContainer
           class="app-header-keyword-list">
        <a *ngIf="mainJaso"
           id="{{ mainJaso }}"
           class="app-header-keyword-btn {{ mainJaso === curJasoIdx ? 'app-header-on' : '' }}"
           (click)="onClickJasoIdx($event, mainJaso)">{{ mainJaso }}</a>
        <a *ngFor="let jaso of jasoList"
           id="{{ jaso }}"
           class="app-header-keyword-btn {{ jaso === curJasoIdx ? 'app-header-on' : '' }}"
           (click)="onClickJasoIdx($event, jaso)">{{ jaso[0] }}</a>
      </div>
    </div>
    <div class="app-header-return-icon" *ngIf="mainJaso" (click)="onClickJasoIdx($event, null)"></div>

  </section>

  <!-- article class="keyword-filter-box">

    <div class="filter-box">
      <div class="{{ showStarFilterMenu ? 'sbox on' : 'sbox' }}">
        <a class="set" (click)="showStarFilterMenu = !showStarFilterMenu">
          {{ curStarFilterItem.text ? curStarFilterItem.text : '' }}
          <i class="{{curStarFilterItem.class}}" *ngIf="curStarFilterItem.class"></i>
        </a>

        <ul class="select-menu" *ngIf="showStarFilterMenu">
          <li *ngFor="let starFilterItem of starFilterItems">
            <a (click)="SetStarFilter(starFilterItem.value)">
              {{ starFilterItem.text ? starFilterItem.text : '' }}
              <i class="{{starFilterItem.class}}" *ngIf="starFilterItem.class"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>

  </article -->


</section>
